/** Operator-facing wall clock. Brazil has had no DST since 2019 (always UTC−3). */
export const BRASILIA_TIME_ZONE = "America/Sao_Paulo";
